<div class="mainDiv">
  <div style="height: 7%;">
    <button class="matbtn1" mat-icon-button (click)="toggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <ng-container *ngIf="this.service.miniSidebarOpen === false">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
      <mat-tree-node *matTreeNodeDef="let node">
        <li class="mat-tree-node">
          <button mat-icon-button (mouseenter)="OnMouseOver(node)" (click)="navigateToPage(node)">
            <mat-icon fontSet="material-icons-outlined">{{ node.icon }}</mat-icon>
          </button>
          <span class="clickable" (click)="navigateToPage(node)" style="white-space: nowrap;" [ngStyle]="{'display': !service.miniSidebarOpen ? 'inline' : 'none'}">{{ node.name }}</span>
        </li>
        @if (node.hovered && this.service.miniSidebarOpen && node.icon) {
        <div class="hoverThing" style="padding: 15px;" (mouseleave)="node.hovered = false;">
          <span class="clickable" (click)="navigateToPage(node)">{{ node.name }}</span>
        </div>
        }
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodeToggle [cdkTreeNodeTypeaheadLabel]="node.name">
        <div class="mat-tree-node">
          <button mat-icon-button (mouseenter)="OnMouseOver(node)" (click)="navigateToPage(node)"><mat-icon fontSet="material-icons-outlined">{{ node.icon }}</mat-icon></button>
          <mat-label style="white-space: nowrap;" [ngStyle]="{'display': !service.miniSidebarOpen ? 'inline' : 'none'}" class="clickable" matTreeNodeToggle (click)="navigateToPage(node)"> {{ node.name }}</mat-label>
          <button style="margin-left: auto;" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? "expand_less" : "expand_more" }}
            </mat-icon>
          </button>
        </div>
        <div class="submenu-wrapper" [@slideVertical]="treeControl.isExpanded(node) ? 'open' : 'closed'">
          @for (childNode of node.childMenus; track childNode) {
          <mat-tree-node>
            <div class="mat-tree-node submenu-item">
              <span class="clickable" (click)="navigateToPage(childNode)" [ngStyle]="{ 'display': !service.miniSidebarOpen ? 'inline' : 'none' }">
                {{ childNode.name }}
              </span>
            </div>
          </mat-tree-node>
          }
        </div>
        @if (node.hovered && service.miniSidebarOpen && node.icon) {
        <div class="hoverThing" (mouseenter)="node.hovered = true" (mouseleave)="node.hovered = false">
          <div class="mat-tree-node">
            <mat-label class="clickable" (click)="navigateToPage(node)"> {{ node.name }} </mat-label>
          </div>
          @if (node.childMenus?.length > 0) {
          <ul>
            @for (childNode of node.childMenus; track childNode) {
            <mat-tree-node>
              <li class="mat-tree-node">
                <span class="clickable" (click)="navigateToPage(childNode)">
                  {{ childNode.name }}
                </span>
              </li>
            </mat-tree-node>
            }
          </ul>
          }
        </div>
        }
      </mat-tree-node>
    </mat-tree>
  </ng-container>
  <ng-container *ngIf="this.service.miniSidebarOpen === true">
    <ng-container *ngFor="let menu of dataSource.data; let i = index">
      <ng-container *ngIf="menu.childMenus?.length; else noChildrenMenu">
        <mat-menu #menuRef="matMenu">
          <ng-container *ngFor="let menuItem of menu.childMenus">
            <button mat-menu-item (click)="navigateToPage(menuItem)">
              <mat-icon *ngIf="menuItem.icon !== ''">{{ menuItem.icon }}</mat-icon>
              <span>{{ menuItem.name }}</span>
            </button>
          </ng-container>
        </mat-menu>
        <button matIconButton [matTooltip]="menu.name" matTooltipPosition="right" [matMenuTriggerFor]="menuRef">
          <mat-icon fontSet="material-icons-outlined">{{ menu.icon }}</mat-icon>
        </button><br />
      </ng-container>
      <ng-template #noChildrenMenu>
        <button matIconButton [matTooltip]="menu.name" matTooltipPosition="right" (click)="navigateToPage(menu)">
          <mat-icon fontSet="material-icons-outlined">{{ menu.icon }}</mat-icon>
        </button><br />
      </ng-template>
    </ng-container>
  </ng-container>
</div>
